import { render } from "./trash-icon.svg?vue&type=template&id=66009a88"
import script from "./trash-icon.svg?vue&type=script&lang=js"
export * from "./trash-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2248/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__